module.exports = __webpack_public_path__ + "img/闭嘴.7e38a61a.gif";